import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col, Form, Row, Typography, UploadFile, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
// import SettingFactoryForm from "./SettingFactory";
// uuid
import { v4 as uuidv4, validate } from "uuid";
import { useUpdateFactory } from "hooks/useAuth";
import { getAuthProfile } from "services/authAPI";
import { setProfileAndContact } from "store/slices/authSlice";
import { useAppDispatch } from "store";
import SettingLineAlertForm from "./SettingLineAlertForm";
import { useGetTokenLine, useUpdateTokenLine } from "hooks/useLine";

// type Location = {
//   lat: number;
//   lng: number;
// }

const SettingLineAlert = () => {

  const navigate = useNavigate();

  const { data, isLoading: isLoadingTokenLine, refetch: refetchToken } = useGetTokenLine() 

  const { mutate, isPending } = useUpdateTokenLine();

  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    mutate({
      token: values.token || "",
      channel_id: values.channelId || "",
      liff_id: values.liffId || "",
      line_oa_token: values.line_oa_token || ""
    }, {
      onSuccess: (data) => {
        if (data.status === "success") {
          message.success("บันทึกสำเร็จ");
          refetchToken();
        } else {
          message.error("บันทึกไม่สำเร็จ");
        }
      },
      onError: (error) => {
        message.error("บันทึกไม่สำเร็จ");
      },
    });
  }
  useEffect(() => {
      form.setFieldsValue({
        channelId: data?.data?.channel_id,
        liffId: data?.data?.liff_id,
        token: data?.data?.token,
        line_oa_token: data?.data?.line_oa_token
      });
  }, [data]);
  return (
    <>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/setting");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>ตั้งค่าLine Application</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <WrapperAll>
              <SettingLineAlertForm
                form={form}
                onFinish={onFinish}
                data={data?.data}
              />
            </WrapperAll>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default SettingLineAlert;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: #efefef;
`;
